import { isMobile } from "lib/hooks/useIsMobile";

export const backgroundImageStyle = ({
  img,
  mobileImg,
  mobileGamma,
  styles = {},
  gamma = styles.gamma || 0,
  textShadow = "1px 1px 1px darkslategray",
  backgroundColor,
}) => {
  if (backgroundColor) return { backgroundColor };
  if (!img) return {};

  if (mobileGamma && isMobile()) gamma = mobileGamma;
  if (mobileImg && isMobile()) img = mobileImg;
  const gammaColor = gamma > 0 ? 255 : gamma < 0 ? 0 : undefined;
  const absGamma = Math.abs(gamma);

  const url = imageUrl(img);
  const backgroundImage = !gamma
    ? `url('${url}')`
    : `linear-gradient(rgba(${gammaColor}, ${gammaColor}, ${gammaColor}, ${absGamma}), rgba(${gammaColor}, ${gammaColor}, ${gammaColor}, ${absGamma})), url('${url}')`;

  return {
    backgroundImage: backgroundImage,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    textShadow,
  };
};

export const imageUrl = (img) => (isFile(img) ? `${process.env.PUBLIC_URL}/static/images/${img}` : img);
const isFile = (url) => !(url.startsWith("http") || url.startsWith("/"));
